import { Component, Input, OnInit } from '@angular/core';
import { ModelList } from 'projects/core/src/include/modellist';
import { ToDo } from '../../todo';
import { UntypedFormBuilder } from '@angular/forms';
import { TodoService } from '../../services/todo.service';
import { DetailComponent } from './detail/detail.component';
import { Filter, FilterMode } from 'projects/core/src/include/structures';

@Component({
  selector: 'app-todo',
  templateUrl: './list.component.html',
  styleUrl: './list.component.css'
})
export class ListComponent extends ModelList<ToDo> implements OnInit {

  @Input()
  id_address:any=0


  constructor(
      private fb1: UntypedFormBuilder,
      private todoService: TodoService,
    ) { 
      super(todoService,fb1);
      this.detailViewModal=DetailComponent;
    }

    filter_search:Filter=new Filter();
    filter_status:Filter=new Filter();
    filter_id_address:Filter=new Filter();
  
  
    ngOnInit(): void {

      this.filter_search.mode=FilterMode.like;
      this.filter_search.fields=[];
      this.filter_search.fields.push("t.description");
      this.filter_search.fields.push("a.name");
      this.filter_search.value="";
      this.filter.push(this.filter_search);
  
      this.filter_status.mode=FilterMode.normal;
      this.filter_status.fields=[];
      this.filter_status.fields.push("t.status");
      this.filter_status.value="1";
      this.filter.push(this.filter_status);

      this.filter_id_address.mode=FilterMode.normal;
      this.filter_id_address.fields=[];
      this.filter_id_address.fields.push("t.id_address");
      this.filter_id_address.value=this.id_address;
      this.filter.push(this.filter_status);


      this.getItems();
    }

} 
